import { render, staticRenderFns } from "./CekResi.vue?vue&type=template&id=5910eae2&"
import script from "./CekResi.vue?vue&type=script&lang=js&"
export * from "./CekResi.vue?vue&type=script&lang=js&"
import style0 from "./CekResi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports